import {makeTrackEvent} from './makeTrackEvent';

export const llmMagicGeneration = makeTrackEvent<
  {
    entity: string;
    project: string;
    task: string;
    area: string;
    metadata?: Record<string, any>;
  },
  {
    _description: `User triggered an LLM generation`;
    _location: 'Various LLM-powered interfaces throughout the application';
    _motivation: 'Track usage of AI-powered generation features across different contexts';
    entity: {
      description: 'Entity where generation occurred';
      exampleValues: ['my-entity'];
    };
    project: {
      description: 'Project where generation occurred';
      exampleValues: ['my-project'];
    };
    task: {
      description: 'Type of generation task';
      exampleValues: ['generate_rows', 'generate_cell', 'generate_prompt'];
    };
    area: {
      description: 'Area where generation was triggered';
      exampleValues: ['create_dataset', 'edit_dataset', 'create_monitor'];
    };
    metadata: {
      description: 'Optional metadata specific to the generation context';
      exampleValues: [
        {fieldName: 'description'},
        {numRows: 10},
        {modelType: 'gpt-4'},
      ];
    };
  }
>('Weave magic LLM generation');

export const llmMagicGenerationFailure = makeTrackEvent<
  {
    entity: string;
    project: string;
    task: string;
    area: string;
    metadata?: Record<string, any>;
  },
  {
    _description: `LLM generation failed`;
    _location: 'Various LLM-powered interfaces throughout the application';
    _motivation: 'Track failures in AI-powered generation features to monitor reliability and identify issues';
    entity: {
      description: 'Entity where generation failed';
      exampleValues: ['my-entity'];
    };
    project: {
      description: 'Project where generation failed';
      exampleValues: ['my-project'];
    };
    task: {
      description: 'Type of generation task that failed';
      exampleValues: ['generate_rows', 'generate_cell', 'generate_prompt'];
    };
    area: {
      description: 'Area where generation failure occurred';
      exampleValues: ['create_dataset', 'edit_dataset', 'create_monitor'];
    };
    metadata: {
      description: 'Optional metadata specific to the failure context (e.g., error message, error type)';
      exampleValues: [
        {error: 'Network timeout'},
        {errorType: 'APIError'; statusCode: 429},
        {modelType: 'gpt-4'; errorMessage: 'Rate limit exceeded'},
      ];
    };
  }
>('Weave magic LLM generation failure');
